<template>
  <b-container fluid>
    <div class="row">
      <div class="col-lg-4" v-for="kpi in kpis">
        <highcharts :options="kpi"></highcharts>
      </div>
    </div>
  </b-container>  
</template>

<script>
 import { mapMutations, mapState } from 'vuex'
 import {Chart} from 'highcharts-vue'
 import QUnit from '@/api/QUnit'

 export default {
   components: {
     highcharts: Chart 
   },
   data() {
     return {
       start_date: null,
       end_date: null,
       kpis: []
     }
   },
   computed: {
     ...mapState([
       'sitePath',
       'current_business_process',
       'processID',
       'filterDates',
     ]),
   },
   mounted(){
     this.setDates()
     this.updateReports()
   },
   methods: {
     setDates() {
       if (this.filterDates.length < 1) {
         var today = new Date()
         this.end_date   = today.toISOString().slice(0,10)
         this.start_date = new Date(today.setDate(today.getDate() - 30)).toISOString().slice(0,10)
       } else {
         this.start_date = this.filterDates[0];
         this.end_date   = this.filterDates[1];
       }
     },
     updateReports(){
       if(this.end_date >= this.start_date)
       {
         if (this.$auth.isAuthenticated() && this.$session.exists('user')) {
           this.SET_BUSINESS_PROCESS(this.$route.query.business_process)
           
           QUnit.getExplorerKPI(
             this.sitePath,
             this.current_business_process,
             this.start_date,
             this.end_date

           ).then(data => {
             this.kpis = data.kpis
           })
         }
       }
       else
       {
         alert("End date has to be greater than start date")
       }
     },
     ...mapMutations([
       'SET_BUSINESS_PROCESS',
     ]),
   },
   watch: {
     filterDates(newValue, oldValue) {
       this.setDates();
       this.updateReports();
     },
     start_date(newValue, oldValue){
       if(this.end_date < newValue && oldValue != null)
         this.start_date = oldValue
     },
     end_date(newValue, oldValue){
       if(newValue < this.start_date && oldValue != null)
         this.end_date = oldValue
     }
   }

 }
</script>
